import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Privilege } from '../models/privilege.model';
import { RoleService } from '../services/role.service';
@Component({
  selector: 'app-service-type',
  templateUrl: './service-type.component.html'
})
export class ServiceTypeComponent {
  constructor(private service: RoleService, private router: Router) { }

  ngOnInit() {
    /*if (!this.service.isAuthorized(Privilege.ServiceType))
      this.router.navigate(['']);*/
  }
}
